import { useAuthorization } from "../components/Authorization";

const useIsDispatcher = () => {
  const AdminFleetAuth = useAuthorization(["ADMIN", "FLEET"]);
  const DispatcherAuth = useAuthorization(["DISP"]);
  return DispatcherAuth && !AdminFleetAuth;
};

export default useIsDispatcher;
